export default defineNuxtRouteMiddleware(to => {
	const source = to.meta.cmsUrlResolution?.source;
	if (!['cmsstaticcontent', 'staticcontent'].includes(source)) return;
	const nuxtApp = useNuxtApp();
	const data = {controller: source, action: 'index', contentType: 'page', template: source === 'cmsstaticcontent' ? 'CmsstaticcontentDefault' : 'StaticcontentDefault', bodyClass: 'page-staticcontent'};
	nuxtApp.$appGlobalData = {...nuxtApp.$appGlobalData, ...data};
	Object.assign(to.meta, data, {languageUrls: []});
	if (import.meta.server) setResponseStatus(useRequestEvent(), 200);
});
